var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input',{attrs:{"disabled":_vm.disabled,"read-only":_vm.readonly,"placeholder":_vm.placeholder},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }